// NOTE: This file is a duplicate of Ready/apps/workkeys/src/modules/reporting/helpers/workkeysReplaceTerms.ts
// with an additional getTerm() wrapper function for qti-pwa.
// When qti-pwa is merged into the Ready monorepo, this file can be removed and replaced with the one in WorkKeys.

import {
  WORKKEYS_REPLACE_TERMS,
  WORKKEYS_REPLACE_URL_SUBPAGE,
  WORKKEYS_REPLACE_URL_CONTENT_TYPE,
  WORKKEYS_REPLACE_QUERY_CONTENT_TYPE,
  WORKKEYS_REPLACE_QUERY_CONTENT_TYPE_REVERSE,
  WORKKEYS_REPLACE_URL_CONTENT_TYPE_REVERSE
} from "../constant/workkeysReplaceTerms"

const isWorkkeys = process.env.REACT_APP_PROJECT_ID?.includes('workkeys')

export const getWorkkeysReplaceTerm = (
  initialWord: string,
  capitalize: boolean = false
) => {
  if (!initialWord) {
    return ""
  }

  const lowerCaseInitialWord = initialWord.toLowerCase()

  const resultWord = WORKKEYS_REPLACE_TERMS[lowerCaseInitialWord]

  if (!resultWord) {
    return initialWord
  }

  if (capitalize) {
    return resultWord
      .split(" ")
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
  }

  return resultWord
}

/**
 * Returns the appropriate term based on the environment (WorkKeys or Ready).
 * If the environment is WorkKeys, it returns the WorkKeys replacement term.
 * Otherwise, it returns the original term for Ready as-is.
 *
 * @param term - The term with correct capitalization (e.g., 'MasteryPrep', 'Practice Test')
 * @param capitalize - Only used for WorkKeys terms (capitalizes replacement terms from lookup table)
 * @returns The appropriate term based on the environment
 */
export const getTerm = (term: string, capitalize: boolean = false): string => {
  if (!term) {
    return ""
  }

  if (isWorkkeys) {
    return getWorkkeysReplaceTerm(term, capitalize)
  }

  return term
}

export const getWorkkeysReplaceUrlSubpage = (subpage: string) => {
  return WORKKEYS_REPLACE_URL_SUBPAGE[subpage] || subpage
}

export const getWorkkeysReplaceUrlContentType = (contentType: string) => {
  return WORKKEYS_REPLACE_URL_CONTENT_TYPE[contentType] || contentType
}

export const getWorkkeysReplaceUrlContentTypeReverse = (
  contentType: string
) => {
  return WORKKEYS_REPLACE_URL_CONTENT_TYPE_REVERSE[contentType] || contentType
}

export const getWorkkeysReplaceQueryContentType = (contentType: string) => {
  return WORKKEYS_REPLACE_QUERY_CONTENT_TYPE[contentType] || contentType
}

export const getWorkkeysReplaceQueryContentTypeReverse = (
  contentType: string
) => {
  return WORKKEYS_REPLACE_QUERY_CONTENT_TYPE_REVERSE[contentType] || contentType
}
